import PSA from '../../psa';
import Utils from '../../utils/Utils';

const TOP_OFFS = 85;

export default class ScrMen {

	constructor(properties) {
		Utils.bindAll(this, ["onReady", "onRender"]);
		const parent = rap.getObject(properties.parent);
		this.pid = properties.parent;
		this.parent = parent;
		const cwd = parent.getData('pisasales.CSTPRP.CWD') || {};
		this.cwd = cwd;
		this._idw = cwd.idw || '';

		this.scrUpBtn = null;
		this.scrDwnBtn = null;
		this.menCnt = null;
		this.menWdg = null;
		this.upTmr = null;
		this.dwnTmr = null;
		this.queTmr = null;
		this.itmHgt = 0;
		this.inrHgt = 0;
		this.orgTop = 0;
		this.emptySep = null;
		this.schQue = "";
		this.ready = false;
		this.dead = false;
		this.mnuVis = false;
		this.bscMgr = null;
		this.scrollHgt = 0;
		this.storedItemCount = 0;
		this._debouncedHgtClc = null;

		rap.on("render", this.onRender);
	}

	destroy() {
		this._onDisappear();
		this.ready = false;
		this.dead = true;
		this.bscMgr = null;
		rap.off("render", this.onRender);
		if ( this.upTmr ) {
			const t = this.upTmr;
			this.upTmr = null;
			t.stop();
			t.dispose();
		}
		if ( this.dwnTmr ) {
			const t = this.dwnTmr;
			this.dwnTmr = null;
			t.stop();
			t.dispose();
		}
		if ( this.queTmr ) {
			const t = this.queTmr;
			this.queTmr = null;
			t.stop();
			t.dispose();
		}
		if ( this.scrUpBtn ) {
			this.scrUpBtn.dispose();
		}
		if ( this.scrDwnBtn ) {
			this.scrDwnBtn.dispose();
		}
		if ( this.emptySep ) {
			this.emptySep.dispose();
		}
		if ( this.menWdg ) {
			const wdg = this.menWdg;
			this.menWdg = null;
			wdg.removeEventListener("resize", this._onRsz, this);
			wdg.removeEventListener("changeVisibility", this._onVsbChg, this);
			wdg.removeEventListener("mousedown", this._onMenDwn, this);
			wdg.removeEventListener("mouseup", this._onMenUp, this);
			wdg.removeEventListener("mouseover", this._onMenOvr, this);
			wdg.removeEventListener("mouseout", this._onMenOut, this);
			wdg.removeEventListener("changeCapture", this._onChgEvt, this);
			wdg.removeEventListener("keydown", this._onKeyDwn, this);
			if ( !wdg.getDisposed() ) {
				wdg.dispose();
			}
		}
		if ( this.menCnt ) {
			const cnt = this.menCnt;
			this.menCnt = null;
			if ( !cnt.getDisposed() ) {
				cnt.dispose();
			}
		}
	}

	onReady() {
		this.iniScrMen();
		if ( !this.inPrc && this.bldScrMen() ) {
			rap.off("render", this.onRender);
			this.ready = true;
			this.bscMgr = PSA.getInst().getBscMgr();
			if ( this.menWdg && this.menWdg.getVisibility() ) {
				this._onAppear();
			}
		}
	}

	onRender() {
		if ( this.dead ) {
			return;
		}
		if ( this.parent && !this.ready ) {
			this.onReady();
		}
		if ( !this.inPrc && this.ready && this.menWdg && this.menWdg._layout ) {
			if ( this.menWdg._layout.getChildrenLength() != this.storedItemCount ) {
				if ( this.menWdg._layout.getChildrenLength() === 1 && this.menWdg._layout.getChildren()[0]._states === undefined ) {
					return;
				}
				this._debouncedHgtClc(this, false);
			}
		}
	}

	iniScrMen() {
		if ( this._debouncedHgtClc === null ) {
			this._debouncedHgtClc = Utils.debounce(this._hdlHgtChg.bind(this), 50);
		}
	}

	bldScrMen() {
		this.inPrc = true;
		const wm = rwt.remote.WidgetManager.getInstance();
		this.menWdg = wm.findWidgetById(this.cwd.idw);
		if ( !this.menWdg || !this.menWdg._layout ) {
			this.menWdg = null;
			return false;
		}
		this.orgTop = this.menWdg.getTop();
		this.menCnt = new rwt.widgets.base.VerticalBoxLayout();
		this.menCnt.setWidth("auto");

		this.menWdg.remove(this.menWdg._layout);
		this.menCnt.add(this.menWdg._layout);

		this.scrollHgt = 0;

		this.scrUpBtn = new rwt.widgets.Button;
		this.scrUpBtn.setAppearance("spinner-button-up");
		this.scrUpBtn.setTabIndex(null);
		this.scrUpBtn.setHeight(15);
		if ( this.scrUpBtn.hasEventListeners("mouseup") ) {
			this.scrUpBtn.__listeners.mouseup = null;
		}

		this.scrDwnBtn = new rwt.widgets.Button;
		this.scrDwnBtn.setAppearance("spinner-button-down");
		this.scrDwnBtn.setTabIndex(null);
		this.scrDwnBtn.setHeight(15);
		if ( this.scrDwnBtn.hasEventListeners("mouseup") ) {
			this.scrDwnBtn.__listeners.mouseup = null;
		}

		this.upTmr = new rwt.client.Timer(150);
		this.upTmr.addEventListener("interval", this._scrMenUp, this);

		this.dwnTmr = new rwt.client.Timer(150);
		this.dwnTmr.addEventListener("interval", this._scrMenDwn, this);

		this.menWdg.add(this.menCnt);

		const self = this;
		const rsz_fnc = function() {
			self._onRsz(self);
		};
		this._rszFnc = rsz_fnc;

		this.menWdg.addEventListener("resize", this._rszFnc, this);
		this.menWdg.addEventListener("changeVisibility", this._onVsbChg, this);
		this.menWdg.addEventListener("mousedown", this._onMenDwn, this);
		this.menWdg.addEventListener("mouseup", this._onMenUp, this);
		this.menWdg.addEventListener("mouseover", this._onMenOvr, this);
		this.menWdg.addEventListener("mouseout", this._onMenOut, this);
		this.menWdg.addEventListener("changeCapture", this._onChgEvt, this);
		this.menWdg.addEventListener("keydown", this._onKeyDwn, this);

		this.queTmr = new rwt.client.Timer(1000);
		this.queTmr.addEventListener("interval", this._clrSeaQue, this);

		this._hdlHgtChg(this, true);
		this.inPrc = false;

		return true;
	}

	_getOrgTop(scope) {
		if ( !scope ) {
			scope = this;
		}
		if ( scope.dead || !scope.menWdg ) {
			return 0;
		}
		if ( scope.orgTop === null ) {
			scope.orgTop = scope.menWdg.getTop();
		}
		return scope.orgTop != null ? scope.orgTop : 0;
	}

	_rstOrgTop() {
		this.orgTop = null;
	}

	_onChgEvt() {
		if ( this.dead || !this.menWdg || !this.menWdg._layout ) {
			return;
		}
		this.scrollHgt = this.menWdg._layout.getTop();
	}

	_onMenDwn(evt) {
		this.upTmr.stop();
		this.dwnTmr.stop();
		const evtTgt = evt.getTarget();
		if ( evtTgt == this.scrUpBtn ) {
			this._onUpBtnDwn(evt);
		} else if ( evtTgt == this.scrDwnBtn ) {
			this._onDwnBtnDwn(evt);
		}
	}

	_onMenUp(evt) {
		this.upTmr.stop();
		this.dwnTmr.stop();
		const evtTgt = evt.getTarget();
		if ( evtTgt == this.scrUpBtn ) {
			this._onUpBtnUp(evt);
		} else if ( evtTgt == this.scrDwnBtn ) {
			this._onDwnBtnUp(evt);
		}
	}

	_onMenOvr(evt) {
		const evtTgt = evt.getTarget();
		if ( evtTgt == this.scrUpBtn ) {
			this._onUpBtnOvr(evt);
		} else if ( evtTgt == this.scrDwnBtn ) {
			this._onDwnBtnOvr(evt);
		}
	}

	_onMenOut(evt) {
		const evtTgt = evt.getTarget();
		if ( evtTgt == this.scrUpBtn ) {
			this._onUpBtnOut(evt);
		} else if ( evtTgt == this.scrDwnBtn ) {
			this._onDwnBtnOut(evt);
		}
		this.upTmr.stop();
	}

	_onUpBtnDwn() {
		if ( this.menWdg ) {
			this.menWdg.setAutoHide(false);
			this._scrMenUp();
		}
	}

	_onUpBtnUp() {
		if ( this.menWdg ) {
			this.menWdg.setAutoHide(true);
		}
	}

	_onUpBtnOvr() {
		this.upTmr.start();
	}

	_onUpBtnOut() {
		this.upTmr.stop();
	}

	_onDwnBtnDwn() {
		if ( this.menWdg ) {
			this.menWdg.setAutoHide(false);
			this._scrMenDwn();
		}
	}

	_onDwnBtnUp() {
		if ( this.menWdg ) {
			this.menWdg.setAutoHide(true);
		}
	}

	_onDwnBtnOvr() {
		this.dwnTmr.start();
	}

	_onDwnBtnOut() {
		this.dwnTmr.stop();
	}

	_clrSeaQue() {
		this.schQue = "";
		this.queTmr.stop();
	}

	_onKeyDwn(evt) {
		if ( this.dead || !this.menWdg || !this.menWdg._layout ) {
			return;
		}
		if ( this.menWdg.isVisibility() ) {
			const keyID = evt.getKeyIdentifier();
			let avaHgt = null;
			const men = this.menWdg;
			const isSclEnb = men.getChildren() !== null && men.getChildrenLength() > 2;
			if ( isSclEnb ) {
				const hvrItm = men.getHoverItem();
				if ( keyID === "Up" && hvrItm ) {
					if ( men._layout.getFirstChild() == hvrItm ) {
						avaHgt = men.getHeight() - (2 * (this.scrUpBtn.getHeight() + hvrItm.getHeightValue()));
						men._layout.setTop(avaHgt - this.inrHgt);
					} else if ( hvrItm._element.offsetTop + men._layout.getTop() < hvrItm.getHeightValue() + this.scrUpBtn.getHeight() ) {
						this._scrMenUp();
					}
				} else if ( keyID === "Down" && hvrItm ) {
					if ( men._layout.getLastChild() == hvrItm ) {
						men._layout.setTop(0 + this.scrUpBtn.getHeight());
					} else {
						avaHgt = men.getHeight() - (2 * (this.scrUpBtn.getHeight() + hvrItm.getHeightValue()));
						if ( hvrItm._element.offsetTop > avaHgt ) {
							this._scrMenDwn();
						}
					}
				}
			}
			if ( keyID.length === 1 && /^[a-zA-Z]/.test(keyID) ) {
				this.queTmr.start();
				this.schQue = this.schQue + keyID;
				const exp = "^(" + this.schQue + ")";
				const patt = new RegExp(exp, "ig");
				const arr = men._layout.getChildren();
				for ( let i = 0; i < arr.length; i++ ) {
					const itm = arr[i];
					if ( itm.$el && itm.$el.text && patt.test(itm.$el.text().trim()) ) {
						men.setHoverItem(itm, true);
						if ( isSclEnb ) {
							avaHgt = men.getHeight() - (2 * (this.scrUpBtn.getHeight() + itm.getHeightValue()));
							if ( avaHgt - itm._element.offsetTop < 0 ) {
								men._layout.setTop(avaHgt - itm._element.offsetTop);
							} else {
								men._layout.setTop(0 + this.scrUpBtn.getHeight());
							}
						}
					}
				}
			}
		} else {
			this.menWdg.hide();
		}
	}

	_mouSclMen(evt, scope) {
		if ( scope.dead ) {
			return;
		}
		if ( scope.menWdg && scope.menWdg.getChildren() !== null && scope.menWdg.getChildrenLength() > 1 ) {
			if ( evt.deltaY > 0 ) {
				scope._scrMenDwn();
			} else {
				scope._scrMenUp();
			}
		}
		scope.upTmr.stop();
		scope.dwnTmr.stop();
	}

	_onAppear() {
		if ( !this.mnuVis ) {
			this.mnuVis = true;
			if ( this.bscMgr ) {
				this.bscMgr.onMnuPop(true);
			}
		}
		window.addEventListener("resize", this._rszFnc, true);
	}

	_onDisappear() {
		if ( this._rszFnc ) {
			window.removeEventListener("resize", this._rszFnc);
		}
		if ( this.mnuVis ) {
			this.mnuVis = false;
			if ( this.bscMgr ) {
				this.bscMgr.onMnuPop(false);
			}
		}
	}

	_onVsbChg() {
		if ( this.dead || !this.menWdg ) {
			return;
		}
		if ( this.menWdg.getVisibility() ) {
			this._onAppear();
			this.menWdg.addEventListener("keydown", this._onKeyDwn, this);
			const self = this;
			rwt.client.Timer.once(function() {
				self._hdlHgtChg(self, true);
			}, this, 150);
		} else {
			this._onDisappear();
			this.menWdg.removeEventListener("keydown", this._onKeyDwn);
			this._rstOrgTop();
		}
	}

	_appScrChg(newVal) {
		const self = this;
		const func = function(event) {
			self._mouSclMen(event, self);
		};
		if ( self.dead || !self.menWdg ) {
			return;
		}
		if ( newVal ) {
			if ( this.menWdg.getChildren() !== null && this.menWdg.getChildrenLength() > 2 ) {
				for ( let i = 0; i < this.menWdg.getChildrenLength(); i++ ) {
					if ( this.menWdg.getChildren()[i] instanceof rwt.widgets.Button ) {
						this.menWdg.removeAt(i);
					}
				}
				this.menWdg.setTop(self._getOrgTop(self));
				window.removeEventListener("wheel", func, false);
			}
		} else {
			let wdt = this.menWdg.getInnerWidth();
			if ( this.menWdg._layout && this.menWdg._layout._computeInnerWidth ) {
				wdt = this.menWdg._layout._computeInnerWidth();
			}
			this.scrUpBtn.setWidth(wdt);
			this.menWdg.addAt(this.scrUpBtn, 0);
			this.scrDwnBtn.setWidth(wdt);
			this.menWdg.addAt(this.scrDwnBtn, 2);
			window.addEventListener("wheel", func, false);
		}
	}

	_hdlHgtChg(scope, force) {
		if ( !scope ) {
			scope = this;
		}
		if ( !scope || scope.dead ) {
			return;
		}
		if ( scope.menWdg && scope.menWdg._layout && scope.ready ) {
			const orgTop = scope._getOrgTop(scope);
			const winHgt = Math.max(rwt.html.Viewport.getHeight(), 0);
			const menHgt = scope._cmpMenHgt(scope);
			if ( menHgt > 0 ) {
				const menTop = scope.menWdg.getTop();
				const menBtm = menHgt + menTop;
				const menOutHgt = menHgt;
				const avlHgt = Math.max(winHgt - TOP_OFFS, 0);
				const hok = scope._isHgtOk(avlHgt, menHgt);
				if ( !scope._isAllItmVsb(avlHgt, menBtm) ) {
					if ( !hok ) {
						scope.menWdg.setTop(orgTop);
						scope.menWdg._layout.setTop((scope.scrollHgt !== 0) ? scope.scrollHgt : 15);
						scope.menWdg.setHeight(avlHgt + 15);
						scope.scrDwnBtn.setTop(avlHgt - 15);
					} else {
						const dif = menBtm - winHgt;
						scope.menWdg._layout.setTop(0);
						scope.menWdg.setTop(menTop - dif);
						scope.menWdg.setHeight(menOutHgt);
					}
				} else {
					scope.menWdg._layout.setTop(0);
					scope.menWdg.setHeight(menOutHgt);
					scope.menWdg.setTop(menTop);
				}
				scope._appScrChg(hok);
			} else {
				if ( scope.menWdg._layout.getChildrenLength() === 0 ) {
					if ( !scope.emptySep ) {
						scope.emptySep = new rwt.widgets.MenuItemSeparator();
					}
					scope.menWdg._layout.addAtBegin(scope.emptySep);
					scope.menWdg.setHeight("auto");
					scope.menWdg._layout.getChildren()[0].setWidth(scope.menWdg._layout._computeInnerWidth());
					scope._appScrChg(true);
					scope.storedItemCount = 0;
				}
			}
		}
	}

	_scrMenUp() {
		if ( this.menWdg && this.menWdg._layout ) {
			let top = this.menWdg._layout.getTop();
			if ( top === null ) {
				top = 0;
			}
			const btnHgt = this.scrUpBtn.getHeight();
			const locItmHgt = this.itmHgt;
			let newTop = top + locItmHgt;
			if ( newTop <= locItmHgt ) {
				newTop = Math.min(btnHgt, newTop);
				this.menWdg._layout.setTop(newTop);
			}
		}
	}

	_scrMenDwn() {
		if ( this.menWdg && this.menWdg._layout ) {
			const menTop = this.menWdg._layout;
			let top = menTop.getTop();
			if ( top === null ) {
				top = 0;
			}
			const inrHgt = this.inrHgt;
			const btnHgt = this.scrUpBtn.getHeight();
			const avaHgt = this.menWdg.getHeight() - 2 * btnHgt;
			if ( (inrHgt + top) > avaHgt ) {
				const newTop = top - this.itmHgt;
				menTop.setTop(newTop);
			}
		}
	}

	_cmpMenHgt(scope) {
		if ( !scope ) {
			scope = this;
		}
		let locInrHgt = 0;
		if ( !scope.dead && scope.menWdg && scope.menWdg._layout ) {
			if ( scope.menWdg._layout.hasChildren() ) {
				scope.storedItemCount = scope.menWdg._layout.getChildrenLength();
				const chlds = scope.menWdg._layout.getChildren();
				const rmvChld = [];

				let chlidx = scope.menWdg._layout.getChildrenLength();
				while ( chlidx-- ) {
					const menuItemAtIndex = chlds[chlidx];
					if ( menuItemAtIndex && menuItemAtIndex.hasOwnProperty("__states") ) {
						if ( !menuItemAtIndex.__states.disabled && (menuItemAtIndex.__states.push || menuItemAtIndex.__states.rwt_CASCADE ||
							menuItemAtIndex.__states.rwt_SEPARATOR || menuItemAtIndex.__states.rwt_CHECK) ) {
							locInrHgt += menuItemAtIndex.getOuterHeight();
						} else {
							rmvChld.push(menuItemAtIndex);
						}
					}
				}
				for ( let j = 0, rmvLength = rmvChld.length; j < rmvLength; j++ ) {
					scope.menWdg._layout.remove(rmvChld[j]);
				}

				let rst;
				for ( let jdx = 0, chlLength2 = scope.menWdg._layout.getChildrenLength(); jdx < chlLength2; jdx++ ) {
					jdx = (rst) ? jdx - 1 : jdx;
					rst = false;
					const childItemAtIndex = chlds[jdx];
					if ( childItemAtIndex && childItemAtIndex.hasOwnProperty("__states") ) {
						const isLstorFstItm = (jdx == "0" || jdx == scope.menWdg._layout.getChildrenLength() - 1)
							&& childItemAtIndex.__states.rwt_SEPARATOR;
						const isSepFollowing = (jdx < scope.menWdg._layout.getChildrenLength() - 2 && jdx > 0 && chlds[jdx + 1] && chlds[jdx + 1].hasOwnProperty("__states"))
							? (chlds[jdx + 1].__states.rwt_SEPARATOR && childItemAtIndex.__states.rwt_SEPARATOR)
							: false;

						if ( isLstorFstItm || isSepFollowing ) {
							locInrHgt -= childItemAtIndex.getOuterHeight();
							scope.menWdg._layout.remove(childItemAtIndex);
							rst = true;
						}
					}
				}

				if ( scope.menWdg._layout.getChildrenLength() > 0 ) {
					scope.itmHgt = scope.menWdg._layout.getChildren()[0].getOuterHeight();
				}
			}
			scope.inrHgt = (locInrHgt > 0) ? locInrHgt : 0;
		}
		return locInrHgt;
	}

	_onRsz(self) {
		if ( self.dead ) {
			return;
		}
		if ( self instanceof ScrMen ) {
			if ( self.menWdg && self.menWdg.getVisibility() && self.menWdg._layout !== null ) {
				self._hdlHgtChg(self, true);
			}
		} else if ( this.menWdg && this.menWdg.getVisibility() && this.menWdg._layout !== null ) {
			this._hdlHgtChg(this, true);
		}
	}

	_isHgtOk(winHgt, menHgt) {
		return (winHgt > menHgt);
	}

	_isAllItmVsb(winHgt, menBtm) {
		return (winHgt > menBtm);
	}

	static closeAllMenus() {
		const mmg = PSA.getInst().getMnuMgr();
		if ( mmg ) {
			mmg.closeAllMenus(false);
		}
		ScrMen.closeRapMenus();
	}

	static closeRapMenus() {
		try {
			if ( !rwt || !rwt.widgets || !rwt.widgets.util || !rwt.widgets.util.MenuManager ) {
				return;
			}
			const menuManager = rwt.widgets.util.MenuManager.getInstance();
			if ( !menuManager._objects ) {
				return;
			}
			const menuMap = menuManager._objects;
			for ( let key in menuMap ) {
				const menu = menuMap[key];
				if ( typeof menu.hide === 'function' ) {
					menu.hide();
				}
			}
		} catch ( err ) {
			console.error('ScrMen.closeAllMenus: ' + err, err);
		}
	}

	static register() {
		rap.registerTypeHandler("pisasales.ScrMen", {
			factory: function(properties) {
				return new ScrMen(properties);
			},
			destructor: "destroy",
			methods: [],
			properties: [],
			events: []
		});
	}
}
